import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class States extends Component {
  render() {
    return (
      <EntityList apiRoute='api/states' title='Remorque - États' editTitle='État' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Neuf', Column: 'IsNew'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default States;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/states.js
 **/